import { render, staticRenderFns } from "./SerpStatistics.vue?vue&type=template&id=11074b81&scoped=true&"
import script from "./SerpStatistics.vue?vue&type=script&lang=js&"
export * from "./SerpStatistics.vue?vue&type=script&lang=js&"
import style0 from "./SerpStatistics.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SerpStatistics.vue?vue&type=style&index=1&id=11074b81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11074b81",
  null
  
)

/* custom blocks */
import block0 from "./SerpStatistics.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports